export const BLOG_PAGE_SIZE = 12

export const blogPagePath = (page: number): string => `/blog/strona/${page}`

export const blogPageCount = (articlesCount: number): number =>
  Math.ceil(articlesCount / BLOG_PAGE_SIZE)
